enum UserAuthenticationContext {
  Authorized = 'auth',
  Unknown = 'anon',
}

export { UserAuthenticationContext };

enum ComponentContext {
  DealsPage = 'plp',
  FycFilters = 'fyc_filters',
  ResultsPage = 'srp',
  Carousel = 'carousel',
  Favorites = 'favorites',
  Excursions = 'srp_excursions',
}

export { ComponentContext };
